module.exports = __webpack_public_path__ + "img/object-mark3.70f535e1.png";